import { Link } from "react-router-dom";
import { Button } from "../components/ui";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto text-center space-y-4 py-16">
      <p className="font-mono text-plasma text-sm">404</p>
      <h1 className="font-display text-3xl font-bold">This page doesn't exist</h1>
      <p className="text-muted text-sm">
        The page you're looking for isn't here. Head back and start a launch.
      </p>
      <Link to="/">
        <Button>Back to home</Button>
      </Link>
    </div>
  );
}
